import LoginCard from './Login';

export default LoginCard;
